import {
  type BreakdownItem,
  type MetricRow,
  type ReportDataRow,
  type ReportLoadMoreRow,
  type ReportLoadingRow,
} from "./types";

export function createLoadingRow({
  level,
  parent,
  breakdownPath,
  id = 0,
}: {
  level: number;
  parent: string;
  breakdownPath: BreakdownItem[];
  id?: number;
}): ReportLoadingRow {
  return {
    type: "loading",
    level,
    parent,
    breakdownPath,
    id: `loading-${parent}-${id}`,
  };
}

export function createLoadingRows({
  level,
  parent,
  breakdownPath,
  length = 17,
}: {
  level: number;
  parent: string;
  breakdownPath: BreakdownItem[];
  length?: number;
}): ReportLoadingRow[] {
  return Array.from({ length }).map((_, index) =>
    createLoadingRow({ parent, level, breakdownPath, id: index }),
  );
}

export function createLoadMoreRow({
  level,
  parent,
  breakdownPath,
  page,
  id = 0,
}: {
  level: number;
  parent: string;
  breakdownPath: BreakdownItem[];
  page: number;
  id?: number;
}): ReportLoadMoreRow {
  return {
    type: "load-more",
    level,
    parent,
    breakdownPath,
    page,
    id: `load-more-${parent}-${id}`,
  };
}

export function createDataRow({
  level,
  parent,
  row,
}: {
  level: number;
  parent: string;
  row: MetricRow;
}): ReportDataRow {
  return {
    type: "data",
    level,
    parent,
    id: row.id,
    breakdownPath: row.breakdownPath,
    data: row,
  };
}
